import { jsx as _jsx } from "react/jsx-runtime";
import { IconNameToSvgMapping } from '@/Components/Icon/IconNameToSvgMapping';
export const getFileIconComponent = (iconType, className) => {
    const IconComponent = IconNameToSvgMapping[iconType];
    return _jsx(IconComponent, { className: className });
};
